import { createFetcher } from '../contexts/Fetcher';
import { apiOrganizationProduct } from '../resources/api/apiOrganizationProduct';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { IBasicOrganization } from '../resources/models/IOrganization';

const { useGetDealHistory } = apiOrganizationProduct;

export const DealHistoryFetcher = createFetcher(() => {
  const { organization_id, product_id } = useParams<{ organization_id: string; product_id: string }>();

  const organization = useMemo(() => {
    return organization_id ? ({ id: organization_id } as IBasicOrganization) : void 0;
  }, [organization_id]);

  const { execute } = useGetDealHistory(organization, parseInt(product_id ?? '0', 10));

  return execute;
});
